(function () {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function getGridBody(button) {
    const container = button.parentElement;
    if (container) {
      const gridBody = container.querySelector('.jdgm-grid-body');
      if (gridBody) return gridBody;
    }

    return document.querySelector('.jdgm-grid-body');
  }

  function expandGrid(button) {
    const gridBody = getGridBody(button);
    if (gridBody) {
      gridBody.classList.add('jdgm-grid-body--expanded');
    }
  }

  document.addEventListener('click', (event) => {
    if (!mobileQuery.matches) return;

    const button = event.target.closest('.jm-show-more-button');
    if (!button) return;

    expandGrid(button);
  });
})();
